import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TempProductionService {
  // private apiUrl = "http://localhost:3003/api/tempPrinting";
   private apiUrl = "https://lexipackghana.com:3003/api/tempPrinting";

  constructor(private http: HttpClient) {}
  addTempPrinting(data:any){
    return this.http.post(this.apiUrl+'/addTempPrinting',data);
  }
  getTempPrinting(){
    return this.http.get(this.apiUrl+'/getAllTempPrinting');
  }
  getTempPrintingById(id: string) {
    return this.http.get(this.apiUrl + '/' + id);
  }
  updateTempPrinting(id: string, data: any) {
    return this.http.put(this.apiUrl + '/' + id, data);
  }
}
